console.log("Some example");